import { LandingButton } from '@features/landing/shared/ui/components/LandingButton';
import { LeaderboardType } from '@features/landing/grandprix/typings';

type Props = {
  onClick: () => void;
  leaderboardType: LeaderboardType;
  preset?: 'landing' | 'club';
};

export function AllParticipantsButton({
  leaderboardType,
  onClick,
  preset = 'landing',
}: Props) {
  return (
    <LandingButton
      size="14r-32"
      color={preset === 'club' ? 'club' : 'faded'}
      onClick={onClick}
    >
      {leaderboardType === 'girls' ? (
        <>Все участницы&nbsp;›</>
      ) : (
        <>Все участники&nbsp;›</>
      )}
    </LandingButton>
  );
}
